import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { DEFAULT_STALE_TIME } from '~/constants'
import { TChatbotAgent } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

type TParams = {
  agentId: string
  queryOptions?: Partial<
    UseQueryOptions<HttpServiceBaseResponse<TChatbotAgent>>
  >
}

// Public/guest lookup for the chat widget — always hits agent-service's
// unauthenticated `/guest/agents/:agentId`, regardless of the visitor's
// Replify login state, so a logged-in session for a different org can never
// trip an org-scope check meant for dashboard access.
const useGetGuestAgent = ({ agentId, queryOptions }: TParams) => {
  return useQuery({
    queryKey: queryKeys.guestAgent(agentId),
    queryFn: () =>
      HttpService.get<TChatbotAgent>(
        { path: pathBuilder(EServerPath.guestAgent, { agentId }) },
        EHttpService.agent,
      ),
    enabled: !!agentId,
    retry: false,
    staleTime: DEFAULT_STALE_TIME,
    ...queryOptions,
  })
}

export default useGetGuestAgent
